import { render, staticRenderFns } from "./SendGoodsModal.vue?vue&type=template&id=cdaba80e&scoped=true"
import script from "./SendGoodsModal.vue?vue&type=script&lang=js"
export * from "./SendGoodsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdaba80e",
  null
  
)

export default component.exports